import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class GridColumn extends React.PureComponent {
    render() {
        const { children, phoneSpan, tabletSpan, desktopSpan } = this.props;

        return (
            <div
                className={classnames(
                    'grid-column',
                    `grid-column--phone-span-${phoneSpan}`,
                    `grid-column--tablet-span-${tabletSpan}`,
                    `grid-column--desktop-span-${desktopSpan}`
                )}
            >
                {children}
            </div>
        );
    }
}

GridColumn.propTypes = {
    phoneSpan: PropTypes.number,
    tabletSpan: PropTypes.number,
    desktopSpan: PropTypes.number,
};

GridColumn.defaultProps = {
    phoneSpan: 12,
    tabletSpan: 12,
    desktopSpan: 12,
};

export default GridColumn;
